// Products that were final sale on the date of the bill being returned, from
// the server's markdowns for that day. { ids: Set, status: "loading" | "done" | "error" }.
// A failed check doesn't block the return; the view warns the cashier instead.
// With markdowns switched off (FASHION_FEATURES) nothing is final sale.
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { fashionPosService } from "../../../../services";
import { FASHION_FEATURES } from "../../../../utils/fashion/features";
import { buildMarkdownsQuery, finalSaleIds, readMarkdowns } from "../../../../utils/fashion/markdowns";

const NONE = new Set();

export const billDay = (order) => {
  const raw = order?.dateordered || order?.orderTime;
  return raw && dayjs(raw).isValid() ? dayjs(raw).format("YYYY-MM-DD") : null;
};

export default function useFinalSaleIds(order, tillData, enabled = FASHION_FEATURES.markdowns) {
  const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
  const day = billDay(order);
  const [state, setState] = useState(() => (enabled ? { ids: NONE, status: "loading" } : { ids: NONE, status: "done" }));

  useEffect(() => {
    if (!enabled) {
      setState({ ids: NONE, status: "done" });
      return undefined;
    }
    if (!bunitId || !order?.documentno) {
      // Nothing to check against: don't leave the return waiting on it.
      setState({ ids: NONE, status: order?.documentno ? "error" : "done" });
      return undefined;
    }
    let live = true;
    setState({ ids: NONE, status: "loading" });
    (async () => {
      const onDate = day || dayjs().format("YYYY-MM-DD");
      const rows = readMarkdowns(await fashionPosService(buildMarkdownsQuery(bunitId, onDate)));
      if (!live) return;
      if (rows === null) setState({ ids: NONE, status: "error" });
      else setState({ ids: finalSaleIds(rows, onDate, bunitId), status: "done" });
    })();
    return () => {
      live = false;
    };
  }, [enabled, bunitId, order?.documentno, day]);

  return state;
}
